export default __webpack_public_path__ + "static/media/pin.c5e9d9cc.svg";